//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The country model
* 
* @param countryCode 
* @param currencyCode 
* @param flagIcon 
* @param labelDe 
* @param labelEn 
* @param labelEs 
* @param labelNl 
*/
@Serializable

data class Country (


      @SerialName(value = "countryCode") @Required val countryCode: kotlin.String,


      @SerialName(value = "currencyCode") @Required val currencyCode: kotlin.String,


      @SerialName(value = "flagIcon") @Required val flagIcon: kotlin.String,


      @SerialName(value = "labelDe") @Required val labelDe: kotlin.String,


      @SerialName(value = "labelEn") @Required val labelEn: kotlin.String,


      @SerialName(value = "labelEs") @Required val labelEs: kotlin.String,


      @SerialName(value = "labelNl") @Required val labelNl: kotlin.String


) {




  }

